export enum TableType {
    Light = 'LIGHT',
    Dark = 'DARK'
}
